import type { TypeConversation, TypeConversationQuery, TypeConversationView } from '@/types/conversation/types.conversation.email';

const PEOPLE = ['customer', 'known', 'new'];
const CORRESPONDENCE: TypeConversationView[] = ['inbox', 'sent', 'archive'];

export function conversationMatches(conversation: TypeConversation, query: TypeConversationQuery, me: string | null): boolean | null {
    if (query.search) return null;
    const views = query.view === 'correspondence' ? CORRESPONDENCE : [query.view];
    if (!conversation.views.some((view) => views.includes(view))) return false;

    if (query.origin === 'people') { if (!PEOPLE.includes(conversation.origin)) return false; }
    else if (query.origin && conversation.origin !== query.origin) return false;

    if (query.status === 'active') { if (conversation.status === 'closed') return false; }
    else if (query.status && conversation.status !== query.status) return false;

    if (query.assignee === 'me' && conversation.assigneeId !== me) return false;
    if (query.assignee === 'none' && conversation.assigneeId !== null) return false;
    if (query.assignee && query.assignee !== 'me' && query.assignee !== 'none' && conversation.assigneeId !== query.assignee) return false;

    if (query.contact && conversation.counterpart.address !== query.contact) return false;
    if (query.customerId && conversation.counterpart.customerId !== query.customerId) return false;
    if (query.unread && conversation.counts.unread === 0) return false;

    const at = new Date(conversation.last.at).getTime();
    if (query.since && at < new Date(query.since).getTime()) return false;
    if (query.before && at >= new Date(query.before).getTime()) return false;

    return true;
}

export default conversationMatches;
